export const STYLE = {
    LOGIN_FIELD_WIDTH: 400,
    LOGIN_FIELD_HEIGHT: 70,
    WIDTH_LABEL: 200
}

export const LABEL = {
    NUMBER: "사번(7자리)",
    INTRO_TITLE:"팀원에게 전하는 따뜻한 영상 메시지"
}
export const MSG ={
    LOGIN_ERR:"사번을 확인해주세요.",
    HINT_NUMBER:"사번을 입력하고 재생 버튼을 누르세요.(7자리)",
    DOWNLOAD_ERR:"Chrome 브라우져를 통해 다운로드 가능합니다.",
    DOWNLOAD:"잠시 후 다운로드가 시작됩니다.",
    DOWNLOAD_GUIDE: "*아이폰 영상 다운로드 오류 발생 시 크롬 브라우저(앱)를 통해 접속 후 다운로드 시도해 보세요!"
    
    
}
